const AppConfig = {
  Api: {
    AppKey: `${process.env.VUE_APP_API_KEY}`,
    Identity: {
      BaseUrl: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}/api/v1`,
      Host: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}`
    },
    Agent: {
      BaseUrl: `${process.env.VUE_APP_AGENT_GATEWAY_BASE_URL}/api/v1`,
      Host: `${process.env.VUE_APP_AGENT_GATEWAY_BASE_URL}`
    },
    Orchestrator: {
      BaseUrl: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}/api/v1`,
      Host: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}`
    },
    Logging: {
      BaseUrl: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}/api/v1`,
      Host: `${process.env.VUE_APP_ORCH_GATEWAY_BASE_URL}`
    },
    Customer: {
      BaseUrl: `${process.env.VUE_APP_CUSTOMER_GATEWAY_BASE_URL}/api/v1`,
      Host: `${process.env.VUE_APP_CUSTOMER_GATEWAY_BASE_URL}`
    }
  }
}

export default AppConfig;
